import { render, staticRenderFns } from "./WidgetsBrand.vue?vue&type=template&id=1406269c&scoped=true&"
import script from "./WidgetsBrand.vue?vue&type=script&lang=js&"
export * from "./WidgetsBrand.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsBrand.vue?vue&type=style&index=0&id=1406269c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1406269c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1406269c')) {
      api.createRecord('1406269c', component.options)
    } else {
      api.reload('1406269c', component.options)
    }
    module.hot.accept("./WidgetsBrand.vue?vue&type=template&id=1406269c&scoped=true&", function () {
      api.rerender('1406269c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/widgets/WidgetsBrand.vue"
export default component.exports